import React from 'react';
import { Container, Row, Col, Card, Carousel } from 'react-bootstrap';
import Baies from '../../../../assets/images/StockCake1724428497.jpg';
import sport from '../../../../assets/images/StockCake-Home.jpg';
import aies from '../../../../assets/images/StockCake1724428252.jpg';
const HeroWokoutComponent = () => {
  const featuredPlans = [
    {
      title: "Burn Fat Cardio Sessions",
      image:Baies
    },
    {
      title: "Big 5: Best Bodyweight Compound Exercises",
      image: sport
    },
    {
      title: "Strong Body Program 4",
      image: aies
    }
  ];

  return (
    <Container className="my-5">
      <h1 className="mb-3">SPORT CATEGORIES</h1>
      <p className="lead mb-5">
        Explore our extensive collection of workout plans and routines tailored to your fitness goals.
        Find the perfect routine to elevate your workout experience.
      </p>

      
      <Carousel 
        indicators={true}
        interval={2000}  
        controls={true}
          pause="hover"
        className="mb-5 w-100"
      >
        {featuredPlans.map((plan, index) => (
          <Carousel.Item key={index}>
            <Card className="bg-dark text-white">
              <Card.Img src={plan.image} alt={plan.title} style={{height: '400px', objectFit: 'cover'}} />
              <Card.ImgOverlay className="d-flex align-items-end">
                <Card.Title className="w-100 bg-primary-light bg-opacity-75 p-3 mb-0">
                  {plan.title}
                </Card.Title>
              </Card.ImgOverlay>
            </Card>
          </Carousel.Item>
        ))}
      </Carousel>
    </Container>
  );
};

export default HeroWokoutComponent;